<template>
    <div class="text-center">
        <v-dialog v-model="dialog" width="500">
            <v-card tile>
                <v-card-title class="title grey lighten-2">
                    {{ title }}
                </v-card-title>
                <v-card-text v-html="message" class="subtitle-1 black--text pt-4"></v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="cancel">No</v-btn>
                    <v-btn color="red darken-1" text @click.native="agree">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
	export default {
		data: () => ({
			dialog: false,
            title: '',
            message: ''
		}),
		methods: {
			open(title, message) {
				this.dialog = true;
				this.title = title;
				this.message = message;
				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject
				})
			},
			agree() {
				this.resolve();
				this.dialog = false
			},
			cancel() {
				this.reject();
				this.dialog = false
			}
		}
	}
</script>
